import {normalizeSeparatorFormat} from './normalize-separator-format';

type Locale = {
    thousandFormat: string,
    decimalFormat: string,
};

/**
 * @description convert stringified formatted number to number
 * @param {string} value - stringified formatted number
 * @param {Locale} locale - User Locale with separator formats
 * @return {number} number
 * @example
 * // With legacy enum format (deprecated)
 * const locale = {
 *     decimalFormat: 'PERIOD',
 *     thousandFormat: 'COMMA'
 * }
 * stringToNumber('1,564.45', locale); // returns 1564.45
 *
 * // With direct separator strings (recommended)
 * const locale = {
 *     decimalFormat: '.',
 *     thousandFormat: ','
 * }
 * stringToNumber('1,564.45', locale); // returns 1564.45
 */
export const stringToNumber = (
    value: string,
    {thousandFormat, decimalFormat}: Locale,
): number => {
    // Normalize format strings (enum or direct) to separator characters
    const thousandSeparator = normalizeSeparatorFormat(thousandFormat);
    const decimalSeparator = normalizeSeparatorFormat(decimalFormat);

    const number = value
        .replace(new RegExp(thousandSeparator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '')
        .replace(new RegExp(decimalSeparator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '.');
    return Number(number);
};
